var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"loadingIcon-comp spinner",attrs:{"data-brandColor":_vm.brandColor}},[_c('div',{staticClass:"bounce1"}),_c('div',{staticClass:"bounce2"}),_c('div',{staticClass:"bounce3"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }